import { motion, AnimatePresence } from 'framer-motion';
import { X, Phone, Mail, MessageCircle } from 'lucide-react';
import { useTranslation } from '@/i18n';

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
}

export function MobileMenu({ open, onClose }: MobileMenuProps) {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            className="fixed inset-0 bg-black/50 z-[60]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="fixed top-0 right-0 bottom-0 w-[280px] bg-brand-navy z-[70] flex flex-col"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          >
            <div className="flex items-center justify-between p-4 border-b border-white/10">
              <span className="font-display text-sm text-white tracking-widest uppercase">
                Menu
              </span>
              <button
                onClick={onClose}
                className="p-2 text-white/80 hover:text-white"
                aria-label="Close menu"
              >
                <X size={20} />
              </button>
            </div>

            <nav className="flex-1 p-6 space-y-6">
              <a
                href="tel:+37455065055"
                className="flex items-center gap-3 text-white/80 hover:text-brand-gold transition-colors"
              >
                <Phone size={18} />
                <span>{t('footer.phone')}: +374 55 065 055</span>
              </a>
              <a
                href="mailto:sales@pullmanyerevan.com"
                className="flex items-center gap-3 text-white/80 hover:text-brand-gold transition-colors"
              >
                <Mail size={18} />
                <span>{t('footer.email')}</span>
              </a>
              <a
                href="https://wa.me/37441788066"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/80 hover:text-brand-gold transition-colors"
              >
                <MessageCircle size={18} />
                <span>{t('footer.whatsapp')}</span>
              </a>
            </nav>

            <div className="p-6 border-t border-white/10">
              <img
                src="https://cdn.prod.website-files.com/6685b27b98911d2b57296782/6685b27b98911d2b572967d1_Pullman_Logo.svg"
                alt="Pullman"
                className="h-6 w-auto brightness-0 invert opacity-50"
              />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
